import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

class InterviewCount extends Component {
  static propTypes = {
    interviewCount: PropTypes.number,
    label: PropTypes.string,
    labelStyle: PropTypes.object
  }

  render () {
    const { interviewCount, label, labelStyle } = this.props

    return (
      <div className='floating'>
        <h1>{interviewCount}</h1>
        <span style={labelStyle}>{label}</span>
      </div>
    )
  }
}

export default observer(InterviewCount)
